import { createSelector } from 'reselect';

import { selectAddToCartState } from '@/domains/shoppingCart/AddToCart/selectors/selectAddToCartState';

export const selectSavedProducts = createSelector(
  selectAddToCartState,
  (addToCartModalState) => addToCartModalState?.savedProductIds ?? [],
);
